module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e653"
    }
  }, [_c('div', {
    staticClass: "tx38"
  }, [_c('p', {
    staticClass: "h11",
    attrs: {
      "id": "d41151791"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap2_thegunse_9781569478004_epub_part2#d136761",
      "id": "d9t001-0"
    }
  }, [_c('b', [_vm._v("PART ONE ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ef9520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap9_thegunse_9781569478004_epub_part9.vue
// module id = 81
// module chunks = 0